module.exports = __webpack_public_path__ + "img/logo-yx.487a3acc.png";